import React, { useState , useEffect } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { useForm, useWatch } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import { getUploadURL , uploadImage } from '../../../../api/common/uploadImageApi';
import { LoadingSpinner } from '../../Component/LoadingSpinner';

import { getBrand , updateBrand } from '../../../../api/admin/brandApi';

const EditBrandModal = ({ show, onHide ,id }) => {

    const { data ,isLoading } = useQuery(['brand',id], () => getBrand(id));

    const { register, handleSubmit, setValue ,formState: { errors } , reset , watch } = useForm();

    // 공개 비공개
    const [isPrivate, setIsPrivate] = useState(true);


    useEffect(() => {
        if (!isLoading && data) {
          setValue('name', data.name);
          setValue('website', data.website);
          setValue('owner', data.owner);
          setValue('phone_number', data.phone_number);
        //   setValue('logo', data.logo);
          setIsPrivate(data.hidden);
        }
      }, [data]);


    const handleCheckboxChange = () => {
        setIsPrivate(!isPrivate); 
    };

    
    const [selectedFileName, setSelectedFileName] = useState('');


  
    const updateBrandMutaion = useMutation((newData) => updateBrand(id, newData), {
        onSuccess : (data) => {
            alert("수정되었습니다")
            reset();
            onHide();
        },
        onError : (data) => {
            console.log("error", data)
        }
    });

    const uploadImageMutation = useMutation(uploadImage,{
        onSuccess : (result) => {
            const newData = {
                name: watch("name"),
                logo: result,
                website: watch("website"),
                owner: watch("owner"),
                phone_number : watch("phone_number"),
                hidden:isPrivate 
            };
            updateBrandMutaion.mutate(newData);
        }
    });
    
    {/* hidden:false => 공개 ,hidden:true => 비공개 */}

    const uploadURLMutaion = useMutation(getUploadURL , {
        onSuccess : (data) => {
            console.log(data);
            uploadImageMutation.mutate({
                uploadURL : data.uploadURL,
                imageURL : data.imageURL,
                file : watch("logo"),
            })
        }
    });


    const onSubmit = (data) => {

      if( !(watch("logo").length === 1)) {
        // 이미지 수정 없을경우
        const newData = {
            name: watch("name"),
            website: watch("website"),
            owner: watch("owner"),
            phone_number : watch("phone_number"),
            hidden:isPrivate 
        };
        updateBrandMutaion.mutate(newData);

      }else{
        uploadURLMutaion.mutate();
      }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFileName(file.name);
        } else {
            setSelectedFileName('');
        }
    };
    
    return (
    <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
            <Modal.Title>브랜드 수정</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <form onSubmit={handleSubmit(onSubmit)}>     
                <div className='input-form'>
                    <div className='input_box'>
                        <p>브랜드 명</p>
                        <input 
                            type='text' 
                            name='name' 
                            className={errors.name ? 'error-input' : ''}
                            {...register('name', { required: '브랜드 명 입력은 필수입니다.' })} />
                            
                        <p>사이트링크</p>
                        <input 
                            type='text' 
                            name='website' 
                            className={errors.website ? 'error-input' : ''}
                            placeholder='반드시 http:// 또는 https:// 를 입력해주세요'
                            {...register('website', { required: '사이트링크 입력은 필수입니다.' })} />
                        
                        <p>로고</p>
                        <div className='imgPreview'>
                            { watch('logo') ? (
                            <></>
                            ) : (
                                <img className='editImg' src={data?.logo}/>
                            )}
                        </div>
                       
                        <div class="filebox">
                            <input  className={errors.logo ? 'upload-name error-input' : 'upload-name'} 
                                    value={selectedFileName} 
                                    placeholder="로고 이미지파일" />
                                    
                            <label htmlFor="logo_file">파일찾기</label> 

                            <input
                                type='file'
                                id='logo_file'
                                name='logo'
                                accept="image/jpg, image/png, image/jpeg"
                        
                                {...register('logo')}
                                onChange={handleFileChange}
                            />
                        </div>

                
                        <p>대표자</p>
                        <input 
                            type='text' 
                            name='owner' 
                            className={errors.owner ? 'error-input' : ''}
                            {...register('owner', { required: '대표자 입력은 필수입니다.' })} />

                        <p>연락처</p>
                        <input 
                            type='text' 
                            name='phone_number' 
                            className={errors.phone_number ? 'error-input' : ''}
                            {...register('phone_number')} />


                        <div class="form-check">
                            <input class="form-check-input" type="checkbox"  id="hiddenCheck" checked={isPrivate} onChange={handleCheckboxChange} />
                            <label class="form-check-label" for="hiddenCheck">
                            비공개
                            </label>
                        </div>
                       
                      
                       
                    </div>
                    <button className='btn_black_1' type="submit">
                        {updateBrandMutaion.isLoading || uploadImageMutation.isLoading || uploadURLMutaion.isLoading
                        ?  <LoadingSpinner /> : '브랜드 수정'} 
                    </button>

                </div>
            </form>
        </Modal.Body>

    </Modal>
  );
};

export default EditBrandModal;
